/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */
export const KeyCodes = {
  escape: 27 as 27,
};
export type KeyCodes = number;
